<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/e7ATYb/tc-custom/9781429972123.jpg?1724847859042" alt="This image is the cover for the book Noise"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Noise
      </h1>
      <p class="bookDescription body article font2">
        <p>Hal Clement, the dean of hard science fiction, has written a new planetary adventure in the tradition of his classic Mission of Gravity. It is the kind of story that made his reputation as a meticulous designer of otherworldly settings that are utterly convincing because they are constructed from the ground up using established principles of orbital mechanics, geology, chemistry, biology, and other sciences.<br/><br/>Kainui is one of a pair of double planets circling a pair of binary stars. Mike Hoani has come there to study the language of the colonists, to analyze its evolution in the years since settlement. But Kainui is an ocean planet. Although settled by Polynesians, it is anything but a tropical paradise. The ocean is 1,700 miles deep, with no solid ground anywhere. The population is scattered in cities on floating artificial islands with no fixed locations. The atmosphere isn't breathable, and lightning, waterspouts, and tsunamis are constant. Out on the great planetary ocean, self-sufficiency is crucial, and  far from any floating city, on a small working-family ship, anything can happen. There are, for instance, pirates. Mike's academic research turns into an exotic nautical adventure unlike anything he could have imagined.<br/><br/><br/><br/>At the Publisher's request, this title is being sold without Digital Rights Management Software (DRM) applied.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Hal Clement
      </h2>
      
      <p class="authorDescription body article"><B>Hal Clement </B>(1922-2003) is a Science Fiction Writers of America Grand Master, and the author of the novels <I>Half Life, Heavy Planet</I> and the classic <I>Mission of Gravity</I>.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Tom Doherty Associates
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?60330fe3